<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i> 酒店基础设置
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-button
          type="primary"
          icon="el-icon-plus"
          class="handle-del mr10"
          @click="addmenu"
          >添加配置</el-button
        >
        <!-- <el-input v-model="query.name" placeholder="用户名" class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button> -->
      </div>
      <el-table :data="tableData" border  class="table" ref="multipleTable" header-cell-class-name="table-header" @selection-change="handleSelectionChange">
        <!-- <template #default="scope">￥{{ scope.row.name }}</template> -->
        <el-table-column prop="id" label="ID" width="66" align="center"></el-table-column>
        <el-table-column prop="facility_name" label="基本配置" align="center"></el-table-column>
        <el-table-column :formatter="timestampToTime" label="创建时间" align="center"></el-table-column>
        <el-table-column label="功能描述" align="center">
          <template #default="{ row }">
            <span>{{
              row.desc == null
                ? "-"
                : row.desc
            }}</span>
          </template>
        </el-table-column>

        <el-table-column label="模块" align="center">
          <template #default="{ row }">
            <span>{{
              row.belong == 1 ? "酒店" :
              row.belong == 2 ? "会议" :
              row.belong == 3 ? "旅行区域" : 
              row.belong == 4 ? "旅游主题" : 
              row.belong == 5 ? "旅游项目标签" : ""
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template #default="scope">
            <el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button type="text" icon="el-icon-delete" class="red" @click="handleDelete(scope.$index, scope.row)" >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination 
        background layout="total, prev, pager, next" 
        :current-page="hoteldatares.page_index" 
        :page-size="hoteldatares.page_size" 
        :total="pageTotal" 
        @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
    <!-- 添加弹出框 -->
    <el-dialog title="添加配置" v-model="addVisible" width="40%">
      <el-form :model="addform" :rules="rules" ref="addform" label-width="100px" class="demo-ruleForm">
         <p class="text_02">注：基础配置为酒店现有配置，如有其它请详细描述~~</p>
        <el-form-item label="基础配置" prop="facility_name">
          <el-input v-model="addform.facility_name"></el-input>
          <p class="text_01">例： 车位、WiFi、发票...</p>
        </el-form-item>
        <el-form-item label="配置描述" prop="desc">
          <el-input v-model="addform.desc" type="textarea"></el-input>
        </el-form-item>

        <el-form-item label="添加模块" prop="belong">
          <el-radio-group v-model="addform.belong">
            <el-radio :label="1">酒店</el-radio>
            <el-radio :label="2">会议</el-radio>
            <el-radio :label="3">旅行区域</el-radio>
            <el-radio :label="4">旅游主题</el-radio>
            <el-radio :label="5">旅游项目标签</el-radio>
          </el-radio-group>
        </el-form-item>

      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="addVisible = false">取 消</el-button>
          <el-button type="primary" @click="addmenuFun('addform')">确定</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 编辑弹出框 -->
    <el-dialog title="编辑" v-model="editVisible" width="40%">
      <el-form :model="editform" :rules="rules" ref="addform" label-width="100px" class="demo-ruleForm">
        <p class="text_02">注：基础配置为酒店现有配置，如有其它请详细描述~~</p>
        <el-form-item label="基础配置" prop="facility_name">
          <el-input v-model="editform.facility_name"></el-input>
          <p class="text_01">例： 车位、WiFi、发票...</p>
        </el-form-item>

        <el-form-item label="添加模块" prop="belong">
          <el-radio-group v-model="editform.belong">
            <el-radio :label="1">酒店</el-radio>
            <el-radio :label="2">会议</el-radio>
            <el-radio :label="3">旅行区域</el-radio>
            <el-radio :label="4">旅游主题</el-radio>
            <el-radio :label="5">旅游项目标签</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="配置描述" prop="user_login">
          <el-input v-model="editform.desc" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="editVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveEdit">确 定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {get_info, post_facilitylist} from "../../api/index";
export default {
  name: "basetable",
  data() {
    return {
      //添加菜单数据
      addform: {
        type:"add",
        facility_name:this.facility_name,
        desc:this.desc,
      },
      editform:{
        type:"edit",
        facility_name:this.facility_name,
        desc:this.desc,
        id:'',
      },
      editId:'',
      rules: {
        facility_name: [
          {
            required: true,
            message: "请输入设施名称",
            trigger: "blur",
          },
        ],
        desc: [
          {
            required: true,
            message: "请输入设施描述",
            trigger: "blur",
          },
        ],
      },
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      multipleSelection: [],
      delList: [],
      editVisible: false,
      addVisible: false,
      pageTotal: 0,
      form: {},
      idx: -1,
      id: -1,
      permissionBeans:[],
      hoteldatares: {
        type: "facility",
        belong:"0",
        keyword: this.keyword, // 搜索
        page_index: 1,
        page_size: 5,
      },
    };
  },
  created() {
    this.getData();
  },
  methods: {
    // 获取 easy-mock 的模拟数据
    getData() {
     get_info(this.hoteldatares).then((res) => {
        this.tableData = res.data.list;
        this.pageTotal = res.data.count;
      });
    },
    //创建时间格式化
    timestampToTime(row) {
      if(row.create_time == 0){
        return "-"
      }else{
        var date = new Date(row.create_time * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
        var D = (date.getDate() +1 < 10 ? '0'+(date.getDate()+1) : date.getDate()+1) + ' ';

        var h = (date.getHours() +1 < 10 ? '0'+(date.getHours()+1) : date.getHours()+1) + ':';
        var m = (date.getMinutes() +1 < 10 ? '0'+(date.getMinutes()+1) : date.getMinutes()+1) + ':';
        var s = (date.getSeconds() +1 < 10 ? '0'+(date.getSeconds()+1) : date.getSeconds()+1) + ' ';
        return Y+M+D+h+m+s;
      }
    },
    // 删除操作
    handleDelete(index,row) {
      // 二次确认删除
      this.$confirm("确定要删除吗？", "提示", {
        type: "warning",
      }).then(() => {
        console.log(row);
        var data = {
          type:'delete',
          id:row.id
        }
         post_facilitylist(data).then((res) => {
             if(res.code == 1){
                console.log(res);
                this.$message.success("删除成功");
                this.tableData.splice(index, 1);
                this.getData();
             }else{
                this.$message.error(res.msg);
             }
            });
        })
        .catch(() => {});
    },
    addmenu() {
      this.addVisible = true;
    },
    // 添加保存
    addmenuFun(addform) {
      console.log(this.addform);
      this.$refs[addform].validate((valid) => {
        if (valid) {
          post_facilitylist(this.addform).then((res) => {
            if (res.code == 1) {
              this.addVisible = false;
              this.$message.success(res.msg);
              this.getData()
            } else {
              console.log(res);
              this.$message.error(res.msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 编辑操作
    handleEdit(index, row) {
      this.idx = index;
      this.editform.facility_name  = row.facility_name;
      this.editform.desc = row.desc
      this.editform.id = row.id
      this.editVisible = true
    },
    // 保存编辑
    saveEdit() {
      console.log(this.editform);
      post_facilitylist(this.editform).then((res) => {
        if(res.code == 1){
            this.$message.success(res.msg);
            this.editVisible = false;
            this.getData()
        }else{
            this.$message.error(res.msg);

        }
      })
    },
    // 分页导航
    handleCurrentChange(currentPage) {
      this.hoteldatares.page_index = currentPage;
      console.log(this.hoteldatares.page_index)  //点击第几页
      this.getData();
    },
  },
};
</script>

<style scoped>
.text_02{
    text-align: center;
    margin-bottom: 30px;
    font-weight: 600;
    color: crimson;
}
.text_01 {
  font-size: 13px;
  color: red;
}
.text_01 a {
  color: royalblue;
  text-decoration: underline;
  margin-left: 3px;
  margin-right: 3px;
}
.title_01 {
  margin-bottom: 20px;
}
.handle-box {
  margin-bottom: 20px;
}

.handle-select {
  width: 120px;
}

.handle-input {
  width: 300px;
  display: inline-block;
}
.table {
  width: 100%;
  font-size: 14px;
}
.red {
  color: #ff0000;
}
.mr10 {
  margin-right: 10px;
}
.table-td-thumb {
  display: block;
  margin: auto;
  width: 40px;
  height: 40px;
}
</style>
